import { render, staticRenderFns } from "./FeiBiaoZhunProductTablePahone.vue?vue&type=template&id=131bb352&scoped=true"
import script from "./FeiBiaoZhunProductTablePahone.vue?vue&type=script&lang=js"
export * from "./FeiBiaoZhunProductTablePahone.vue?vue&type=script&lang=js"
import style1 from "./FeiBiaoZhunProductTablePahone.vue?vue&type=style&index=1&id=131bb352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131bb352",
  null
  
)

export default component.exports